import React, { useEffect, useState, useContext } from "react";
import { GetData } from "../Api";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Printer from "../Components/Printer";
import FilterContext from "../Hooks/Context";
import Filter from "../Components/Filter";
import {factoryStartEndTime} from '../Hooks/Common'

const PrinterView = () => {
  const [menuStatus, SetMenuStatus] = useState(false);
  const [lineDataVisiblity, SetLineDataVisiblity] = useState(true);
  const [printerData, SetPrinterData] = useState();
  const [liveStatus, SetLiveStatus] = useState(true);
  const { t } = useTranslation();
  const filterQueries = useContext(FilterContext);
  const history = useHistory();

  const isEqual = (...objects) =>
    objects.every((obj) => JSON.stringify(obj) === JSON.stringify(objects[0]));

  const GetPrinterData = () => {
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `dashboard/printer?&startTs=${filterQueries.filterRequestQuery.startTs}&endTs=${filterQueries.filterRequestQuery.endTs}&shift=${filterQueries.filterRequestQuery.shift}`
      )
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          SetPrinterData(data);
          SetLineDataVisiblity(false);
        })
        .catch((error) => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("refreshToken");
          // history.push("/");
          
          console.error("error - - - - - - - - -", error);
        });
    }
  };

  useEffect(() => {
    GetPrinterData(1);
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.selectedMenu = "#printer";
    filterQueries.GenerateFilters(filterRequestQuery);
  }, []);

  /* Live Module Starts from Here */

  const [pauseLive, SetPauseLive] = useState(false);
  const [timeInterval, setTimeInterval] = useState(0);
  var timeout, timeIntervalCount;

  const EnableLiveData = (event) => {
    SetPauseLive(false);

    let fset = factoryStartEndTime()
        let startDate = fset.startTs
        let endDate = fset.endTs
  
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.isLive = true;
    filterRequestQuery.startTs = startDate;
    filterRequestQuery.endTs = endDate;
    filterQueries.GenerateFilters(filterRequestQuery);
  }

  useEffect(() => {
    if(!pauseLive) {
      timeout = setTimeout(() => {
        timeIntervalCount = setTimeInterval(timeInterval + 1);
        }, 60000);
    }
  });

  useEffect(() => {
    GetPrinterData(1);
  },[ filterQueries ]);

  useEffect(() => {
    if(filterQueries.filterRequestQuery.isLive) {
      SetPauseLive(false);
    } else {
      SetPauseLive(true);
    }
  },[ filterQueries.filterRequestQuery ]);

  useEffect(() => {
    let myDate = new Date( filterQueries.filterRequestQuery.startTs *1000);
    let gmtString = myDate.toGMTString();
    if(filterQueries.filterRequestQuery.isLive) {
      let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
      filterRequestQuery.isLive = true;
      filterQueries.GenerateFilters(filterRequestQuery);
    } else {
      let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
      filterRequestQuery.isLive = false;
      filterQueries.GenerateFilters(filterRequestQuery);
      clearTimeout(timeout);
      clearInterval(timeIntervalCount);
    }
    
  }, [timeInterval]);

  /* Live Module Ends from Here */


  const ToggleClass = () => {
    SetMenuStatus(!menuStatus);
  };

  return (
    <>
      <h4>{ t("LT_machine_dashboard_printer") }</h4>
      { !pauseLive && (
        <span className="liveStatus">
          { t("LT_live") }{" "}
          <span
            className={`showLive ${liveStatus ? "live-icon" : "relay"}`}
          ></span>
        </span>
      )}
      { pauseLive && <div className='live-btn' onClick={ (event) => { EnableLiveData(event) } }>{t("LT_enable_live_data")}</div>}
      <Filter showDatePicker={false} />
      {printerData && <Printer data={printerData} />}
    </>
  );
};

export default PrinterView;
